import React, { useEffect, useState, useCallback } from 'react'
import { useNavigate } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { useSnackbar } from 'notistack'
import { addTerm } from 'app/redux/store/features/terms'
import utilServices from 'app/services/util-services'
import { defaultTermData } from './defaultTermData'
import AddTermForm from './AddTermForm'
const AddTerm = () => {
    const navigate = useNavigate()
    const dispatch = useDispatch()
    const { enqueueSnackbar } = useSnackbar()

    const [termData, setTermData] = useState({ ...defaultTermData })
    const [apiCallInProgress, setApiCallInProgress] = useState(false)

    const { loading, error } = useSelector((state) => state.terms)

    useEffect(() => {
        if (!apiCallInProgress || loading) return
        setApiCallInProgress(false)
        if (error) handleError(error)
        else {
            enqueueSnackbar('Term added successfully', {
                variant: 'success',
                anchorOrigin: {
                    vertical: 'top',
                    horizontal: 'right',
                },
            })
            // Avoid an immediate refetch in `TermsGrid`; rely on the add payload already merged into Redux.
            navigate('/courses/setup/terms', { state: { navigateFrom: 'save-add-term' } })
        }
    }, [loading])

    function handleError(error) {
        if (error.status === '401') {
            navigate('/profile/signout')
        } else if (error.detail) {
            enqueueSnackbar(error.detail, {
                variant: 'error',
                anchorOrigin: {
                    vertical: 'top',
                    horizontal: 'right',
                },
            })
        } else {
            enqueueSnackbar(error, {
                variant: 'error',
                anchorOrigin: {
                    vertical: 'top',
                    horizontal: 'right',
                },
            })
        }
    }

    const onFieldDataChanged = useCallback((e) => {
        const field = e?.dataField
        if (!field) return
        setTermData((prev) => ({ ...prev, [field]: e.value }))
    }, [])

    const onAddTerm = async () => {
        setApiCallInProgress(true)
        dispatch(
            addTerm({
                ...termData,
                dateStart: utilServices.toUtcStartOfDayForApi(termData.dateStart),
                dateEnd: utilServices.toUtcEndOfDayForApi(termData.dateEnd),
            })
        )
    }

    return (
        <React.Fragment>
            <AddTermForm termData={termData} addTerm={onAddTerm} onFieldDataChanged={onFieldDataChanged} />
        </React.Fragment>
    )
}

export default AddTerm
